module.exports = __webpack_public_path__ + "static/media/checklist.820ae948.svg";